<template>
  <footer class="site-footer">
    <div class="footer-top g-container">
      <div class="brand-col">
        <img src="@/assets/logo-blue.svg" alt="" class="footer-logo" />
        <p class="slogan">一站式电子保函办理平台<br/>专业可靠 · 一键申请 · 最快 3 分钟出函</p>
      </div>
      <div class="link-col">
        <h5>产品服务</h5>
        <a @click="$router.push('/product')">电子投标保函</a>
        <a @click="$router.push('/product')">履约保函</a>
        <a @click="$router.push('/product')">预付款保函</a>
      </div>
      <div class="link-col">
        <h5>用户中心</h5>
        <a @click="$router.push('/attestation?tab=basic')">账号认证</a>
        <a @click="$router.push('/attestation?tab=order')">我的订单</a>
        <a @click="$router.push('/attestation?tab=bill')">我的发票</a>
      </div>
      <div class="link-col">
        <h5>关于我们</h5>
        <a @click="$router.push('/help')">帮助中心</a>
        <a @click="$router.push('/search')">真伪查询</a>
        <a href="javascript:;">联系我们</a>
      </div>
      <div class="contact-col">
        <h5>联系方式</h5>
        <p><i class="ico ico-phone"></i>19179363419 (蒋经理)</p>
        <p><i class="ico ico-fax"></i>0793-3409556</p>
        <p><i class="ico ico-loc"></i>江西省上饶市余干县玉亭镇鄱阳湖大道新建设大厦 8F</p>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="g-container">
        <span>版权所有：余干县城市建设投资开发集团有限公司</span>
        <span class="ml"><a href="https://beian.miit.gov.cn/#/Integrated/index">赣ICP备2022007552号</a></span>
        <span class="ml">友情链接：</span>
        <a class="ml" href="https://ggzy.jiangxi.gov.cn/web/" target="_blank">江西公共资源交易网</a>
        <a class="ml" href="http://www.ygxzfwzx.com/" target="_blank">余干县行政服务中心</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default { name: 'SiteFooter' }
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.site-footer {
  background: #0F172A;
  color: #CBD5E1;
}

.footer-top {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr 1.4fr;
  gap: 40px;
  padding: 64px 24px 48px;
}

.brand-col {
  .footer-logo { height: 32px; opacity: .85; }
  .slogan {
    margin-top: 16px;
    color: #94A3B8;
    font-size: 13px;
    line-height: 1.7;
  }
}

.link-col, .contact-col {
  h5 {
    color: #fff;
    font-size: 15px;
    margin: 0 0 16px;
    font-weight: 600;
  }

  a, p {
    display: block;
    color: #94A3B8;
    font-size: 13px;
    margin: 8px 0;
    cursor: pointer;
    transition: color @duration-fast @ease-out;

    &:hover { color: #fff; }
  }
}

.contact-col {
  .ico {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    vertical-align: -2px;
    background: @primary;
    border-radius: 3px;
  }
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 18px 0;
  font-size: 12px;
  color: #64748B;
  text-align: center;

  a { color: #94A3B8; }
  a:hover { color: #fff; }
  .ml { margin-left: 12px; }
}

// ================= 移动端响应式 =================
@media (max-width: 768px) {
  .footer-top {
    grid-template-columns: 1fr !important;
    gap: 24px;
    padding: 40px 16px 24px;
  }

  .brand-col .slogan { font-size: 12px; }
  .brand-col .footer-logo { height: 28px; }

  .link-col,
  .contact-col {
    padding: 16px;
    background: rgba(255, 255, 255, 0.04);
    border-radius: @radius-md;

    h5 {
      font-size: 15px;
      margin: 0 0 12px;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    }

    a, p {
      display: block;
      color: #94A3B8;
      font-size: 13px;
      margin: 10px 0;
      line-height: 1.5;
      word-break: normal;
    }
  }

  .contact-col {
    .ico {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 8px;
      vertical-align: -2px;
    }
  }
}

@media (max-width: 480px) {
  .footer-bottom {
    font-size: 11px;
    padding: 14px 16px;
    line-height: 1.7;

    span, a, .ml {
      display: inline-block;
      margin: 2px 6px;
    }
  }
}
</style>
